/* eslint-disable indent */
/* global zE */
import { getDeviceAndOS, getGeoInfo } from './utils';

const fieldMapping = {
  email: '13824093241500',
  name: '13824107809052',
  company: '13794836435740',
  language: '13823548800796',
  isCasting: '13794892161564',

  productId: '13794898208668',
  productPageUrl: '13794899047324',
  orderTrackingUrl: '13794894378140',
  orderStatus: '13794877588124',
  orderId: '13794896203676',

  platform: '13794901741468',
  platformType: '13794888010908',
  device: '13794880294300',
  os: '13794917990300',
  countryName: '13823551559196',
  countryCode: '13823554777244',
};

export const showZendeskWidget = (toShow) => {
  if (!zE) {
    return;
  }

  zE('messenger', toShow ? 'show' : 'hide');
};

export const configureZendeskWidget = () => {
  if (typeof zE === 'undefined') {
    console.error('Zendesk API not loaded.');
    return;
  }

  try {
    showZendeskWidget(false);
  } catch (error) {
    console.error('Error configuring Zendesk widget:', error);
    showZendeskWidget(false);
  }
};

export const loadZendeskWidget = (zendeskKey) => {
  if (!zendeskKey) {
    console.error('Zendesk API not loaded, because zendeskKey is not provided');
    return;
  }
  if (window && !window.ZendeskLoaded) {
    window.ZendeskLoaded = true;

    const zdScript = document.createElement('script');
    zdScript.type = 'text/javascript';
    zdScript.async = true;
    zdScript.id = 'ze-snippet';
    zdScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;

    zdScript.onload = configureZendeskWidget;

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(zdScript, firstScript);
  }
};

export const listenToZendeskEvent = (eventType, eventHandler) => {
  if (typeof zE === 'undefined') {
    console.error('Zendesk API not loaded.');
    return;
  }
  zE('messenger:on', eventType, eventHandler);
};

const setWidgetConversationFields = async (additionalData) => {
  const deviceInfo = getDeviceAndOS();
  const geoInfo = await getGeoInfo();

  const originalFields = {
    ...additionalData,
    platformType: additionalData.platform.toLowerCase(),
    isCasting: additionalData.isCasting.toString(),
    device: deviceInfo.device.toLowerCase(),
    os: deviceInfo.os.toLowerCase(),
    // uncomment, if you want to send IP and timezone (for now it's disabled, because of GDPR or smth else)
    // ip: geoInfo.ip,
    // timezone: geoInfo.timezone,
    countryName: geoInfo.countryName,
    countryCode: geoInfo.countryCode,
  };

  const normalizedFields = Object.entries(originalFields)
    .map(([key, value]) => ({
      id: fieldMapping[key] || key,
      value,
    }))
    .filter((item) => item.value !== null);

  zE('messenger:set', 'conversationFields', [...normalizedFields]);
};

export const updateZendeskUserAndStart = (
  {
    email,
    name,
    language,
    company,
    platform,
    rootGetters,
  },
) => {
  if (typeof zE === 'undefined') {
    console.error('Zendesk API not loaded.');
    return;
  }
  showZendeskWidget(true);

  listenToZendeskEvent('open', () => {
    let productInfo = {};
    if (rootGetters.chosenProduct) {
      const { id, pageUrl } = rootGetters.chosenProduct;
      productInfo = {
        productId: id,
        productPageUrl: pageUrl,
      };
      if (rootGetters.chosenProduct.order) {
        const { trackingUrl, status, orderId } = rootGetters.chosenProduct.order;
        productInfo.orderTrackingUrl = trackingUrl;
        productInfo.orderStatus = status.toLowerCase();
        productInfo.orderId = orderId;
      }
    }
    setWidgetConversationFields({
      email,
      name,
      company,
      language,
      platform,
      isCasting: rootGetters['solution/isCasting'],
      ...productInfo,
    });
  });
};
